module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAVCAMAAACeyVWkAAAARVBMVEUAAAAnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrYnbrbt8POjwNwvc7jl6/HM2+lxns1Ig8Ctxt/UO7RhAAAADnRSTlMAjST070zMt64zMOXIUdzNPugAAACMSURBVBjTdZHZEoMgDEXDIopgAJf+/6fWEu/QWjwvhDOZTBYSZhWDCVHN1NATg0lDDpYbdrgk/1K1NjdrPkVGvjMSef7Hk0KYUkKoKHaso9CxluTNScjyJZmgbFVu5cp1XDnWU64H6qKH/bQ7emj95pQR+jZbeRXM1t9Df2eVxXxnLs+3wN2cZetwtzfNlhKp+WibSgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./components/Icon/images/icon_down2_active.png
// module id = ZcXR
// module chunks = 9